import { useSelector } from "react-redux";
import classes from "./ToggleBtn.module.css";

export function ToggleBtn({ isDisabled, setIsDisabled }) {
  const { language } = useSelector((state) => state.global);
  const buttonText =
    language === "en" ? (isDisabled ? "ON" : "OFF") : isDisabled ? "PÅ" : "AV";

  return (
    <div
      className={classes.toggleBtn}
      onClick={() => (setIsDisabled !== null ? setIsDisabled(!isDisabled) : "")}
      style={{
        backgroundColor:
          setIsDisabled === null
            ? "#74dbfc"
            : isDisabled
            ? "#2fc6f6"
            : "#c4c2c2",
        cursor: setIsDisabled === null ? "auto" : "pointer",
      }}
    >
      <span
        style={{
          right: isDisabled ? "5px" : "30px",
        }}
      ></span>
      <p
        style={{
          right: isDisabled ? "28px" : language === "en" ? "5px" : "10px",
          color: isDisabled ? "rgba(255,255,255, 0.6)" : "#333",
        }}
      >
        {buttonText}
      </p>
    </div>
  );
}
